import { weakPasswordMessage } from './auth/password';

/**
 * Turn Supabase auth/database errors into plain, specific messages (never blame the user). Our RPCs raise
 * readable messages, so those are shown as they are; `context: 'invite'` keeps the join page's wording.
 */
export function friendlyError(error: unknown, context?: 'invite'): string {
  const e = error as {
    code?: string;
    message?: string;
    status?: number;
    reasons?: string[];
    weak_password?: { reasons?: string[] };
  } | null;
  switch (e?.code) {
    case 'invalid_credentials':
      return "That email and password don't match. Try again, or reset your password.";
    case 'email_not_confirmed':
      return 'Confirm your email first. Check your inbox for the link we sent.';
    case 'user_already_exists':
    case 'email_exists':
      return 'An account with that email already exists. Sign in instead.';
    case 'display_name_taken':
    case '23505':
      return 'That display name is already taken. Pick another.';
    case 'weak_password':
      return weakPasswordMessage(e ?? {});
    case 'over_email_send_rate_limit':
    case 'over_request_rate_limit':
      return 'Too many attempts. Wait a minute and try again.';
    case 'same_password':
      return 'Choose a password different from your current one.';
    case '22023':
      if (context === 'invite') return 'This invite is no longer valid. Ask for a new one.';
      return e.message ?? "That change isn't possible right now.";
    case 'P0002':
      if (context === 'invite') return "We couldn't find that invite. Check the code and try again.";
      return e.message ?? "We couldn't find that. It may have been removed.";
    case '42501':
      return e.message ?? "You don't have permission to do that.";
    default:
      return e?.message ?? 'Something went wrong. Try again.';
  }
}
